export enum ScrollHandlingEventsEnum {
  AT_BOTTOM = 'AT_BOTTOM',
  AT_TOP = 'AT_TOP',
}
